// Apllication Type에 따라 불러온 환경변수를 이용해서 API 주소를 설정한다.
// 자세한 내용은 /README.md 참고.
import codes from '@/plugins/codes'

const config = {
  ApiUrl: process.env.VUE_APP_AIMS_SERVER_URL,
  ApiKey: process.env.VUE_APP_API_KEY,
  Release: process.env.VUE_APP_RELEASE,
  MapUrl: process.env.VUE_APP_MAP_SERVER_URL,
  LcdUrl: process.env.VUE_APP_LCD_SERVER_URL
}
// console.info('Default config' + JSON.stringify(config))

const getRuntimeConfig = async (productionType, baseUrl) => {
  let runtimeConfig = ''
  switch (productionType) {
    case 'local-server':
      runtimeConfig = await fetch(baseUrl + 'properties_local.json')
      break
    case 'test-server':
      runtimeConfig = await fetch(baseUrl + 'properties_test.json')
      break
    case 'cloud':
      runtimeConfig = await fetch(baseUrl + 'properties_cloud.json?v=' + Date.now(), { cache: 'no-store' })
      break
    default: runtimeConfig = await fetch(baseUrl + 'properties.json')
      break
  }
  return await runtimeConfig.json()
}

const getServerIp = (productionType, json) => {
  // Server 설치버전에서 사용자가 localhost 주소로 접속한 경우 API서버 localhost로 덮어씌운다.
  if (location.hostname === codes.LOCALHOST && productionType === 'server') return codes.LOCALHOST
  return json.serverIp || codes.LOCALHOST
}

const init = async () => {
  const productionType = process.env.VUE_APP_PRODUCTION_TYPE
  const baseUrl = process.env.BASE_URL
  // const mapUrl = process.env.VUE_APP_MAP_SERVER_URL
  if (process.env.VUE_APP_USING_PROPERTIES) {
    return getRuntimeConfig(productionType, baseUrl).then(function (json) {
      // Cloud로 로그인 하면 localhost로 변경후 프록시 적용
      // if (productionType === 'cloud') {
      //   json.protocolType = location.protocol.replace(':', '')
      //   json.serverIp = location.hostname
      //   json.serverPort = location.port
      // }
      // Conditionally hide console logs based on the runtime environment\'
      const keepConsoleEnvs = ['DEVELOPMENT', 'STAGE00', 'BIGVOLUME']
      const currentEnv = (json.envName || '').toUpperCase()
      if (!keepConsoleEnvs.includes(currentEnv)) {
        console.log = function () {}
        console.info = function () {}
        console.debug = function () {}
        console.warn = function () {}
        console.error = function () {}
        console.trace = function () {}
        console.dir = function () {}
        console.table = function () {}
      }

      console.debug('Runtime config: ' + JSON.stringify(json))
      const protocol = json.protocolType || 'http'
      const serverIp = getServerIp(productionType, json)
      const serverPort = json.serverPort || '9001'
      const serverDomain = json.serverDomain || '/'
      const ServerAddress = `${protocol}://${serverIp}:${serverPort}`
      const customRedirect = json.customRedirect
      const amazonMidwayCustomerList = json.amazonMidwayCustomerList
      const newConfig = {
        ApiUrl: ServerAddress + (serverDomain || ''),
        // ApiKey: json.apiKey,
        Release: json.Dashboard_Release,
        MapUrl: json.mapUrl,
        LcdUrl: json.lcdUrl,
        squarePosAppId: json.squarePosAppId,
        pickcelSiteUrl: json.pickcelSiteUrl,
        nStorySiteUrl: json.nStorySiteUrl,
        serverIp: json.serverIp,
        serverPort: json.serverPort,
        protocol: json.protocolType || 'http',
        serverUrl: `${protocol}://${serverIp}${json.subDomain}`,
        subDomain: json.subDomain,
        fullServerIp: `${protocol}://${serverIp}`,
        ToastPosUrl: json.toastPosUrl,
        standardGatewayVer: json.saasStandardGatewayVersion,
        USBGatewayVer: json.saasUSBGatewayVersion,
        Newton7SegGatewayVer: json.newton7SegStandardGatewayVersion,
        saasStandardGatewayFirmwareVersion: json.saasStandardGatewayFirmwareVersion,
        saasLabelFirmwareVersion: json.saasLabelFirmwareVersion,
        cameraPageLogo: json.cameraPageLogo,
        customRedirect: customRedirect,
        amazonMidwayCustomerList: amazonMidwayCustomerList || [],
        a10MapUrl: json.a10MapUrl,
        includeCustomers: json.includeCustomers,
        excludeCustomers: json.excludeCustomers,
        heartlandPosAppId: json.heartlandPosAppId,
        heartlandPosRedirectUrl: json.heartlandPosRedirectUrl,
        releaseNotesUrl: json.releaseNotesUrl,
        dashboardLogo: json.dashboardLogo || false,
        meetingSolutionClientId: json.meetingSolutionClientId,
        meetingSolutionRedirectUrl: json.meetingSolutionRedirectUrl,
        meetingSolutionStoreCode: json.meetingSolutionStoreCode,
        dashboardDomain: json.dashboardDomain,
        powerRailResetGatewayVerion:json.powerRailResetGatewayVerion,
        epsSiteUrl: json.epsSiteUrl,
        cescoDashboardUrl: json.cescoDashboardUrl,
        dicamoDustaUrl: json.dicamoDustaUrl,
        envName: json.envName || '',
        visionUi: json.visionUi || 'legacy',
        directPrefixes: json.directPrefixes,
        solumLinks : json.solumLinks,
        newReleaseNotesURL: json.newReleaseNotesURL || '',
        newUserManualURL: json.newUserManualURL || '',
        serviceAccountDocsUrl: json.serviceAccountDocsUrl || '',
        customerOverviewReportTiming: json.reportTimings.customerOverviewReport,
        labelNotificationsTiming: json.reportTimings.labelNotifications,
        monthlyReportsTiming: json.reportTimings.monthlyReports,
        loadcellRecalibrationNotificationTiming: json.reportTimings.loadcellRecalibrationNotification,
        genieEnabled: json.genieEnabled,
        powerRailBlinkVersion:json.powerRailBlinkVersion
        // oneSignalAppId: json.oneSignalAppId
      }
      Object.assign(config, newConfig)

      return newConfig
    })
  }
}

// Ensure appliedConfig resolves before accessing config properties
export const ensureConfigReady = async () => {
  if (config.appliedConfig instanceof Promise) {
    await config.appliedConfig
  }
}

const appliedConfig = init()
config.appliedConfig = appliedConfig

export default config
